/*
 * @Author: edvardchen
 * @Date:   2017-06-28 21:26:41
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-06-28 21:26:52
 */

export default function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}
